import { useState, useEffect, useRef } from 'react';
import useAuth from './useAuth';
// API
import API from '../API';
const initialState = {
  page: 0,
  transactions: [],
  total_pages: 0,
  total_results: 0
};
export const usePayrollTransactionsListFetch = () => {
  const auth = useAuth();
  const [state, setState] = useState(initialState);
  const [searchValue,setSearchValue] = useState('');
  const [includeInactive,setIncludeInactive] = useState(false)
  const [trigger, setTrigger] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const accessToken = auth.auth.accessToken
  console.log("binne use fetch")
  
  console.log(searchValue)
  const fetchPayrollTransactionsList = async(searchValue)=>{
    try {
      setLoading(true);
      setError(false);
     console.log("binne fetchPayrollTransactionslist")
      const data = await API.fetchPayrollTransactions(searchValue,"",includeInactive,"",accessToken)
     
      console.log(data.transactions)
      setState({  
        ...data
        
      }
      )

      setLoading(false)
      setTrigger(false)

    } catch (error) {
      console.log(error)
      setError(true);
    }
  }

  useEffect(()=>{
    console.log("useEffect is getrigger")
    setState(initialState)
    fetchPayrollTransactionsList(searchValue)
  },[searchValue,trigger,includeInactive]);

return{state,loading,error,setSearchValue,setIncludeInactive,setLoading,setTrigger};


};
